export default __webpack_public_path__ + "static/media/108_pharaok.b34ef624.webp";